<template>
  <div class="thumbnail-container">
    <div class="image-container">
      <BbIcon name="slides" class="default-thumb" />
    </div>
  </div>
  <div class="footnote-details">
    <EditableField
      :value="customTitle"
      v-model="customTitle"
      :isEditing="isEditableTitle"
      :displayEditingIcon="displayIcon"
      @cancel="$emit('cancel')"
      @set-editable="$emit('set-editable')"
      @update="$emit('update', $event)"
    />
  </div>
</template>
<script>
import { ref, watch } from 'vue';

import EditableField from '~/components/common/EditableField.vue';

export default {
  components: { EditableField },
  emits: ['update', 'cancel', 'set-editable'],
  props: {
    title: {
      type: String,
      default: '',
    },
    isEditableTitle: {
      type: Boolean,
      default: false,
    },
    displayIcon: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const customTitle = ref(props.title);

    watch(
      () => props.title,
      (newValue) => {
        customTitle.value = newValue || props.title;
      },
    );

    return { customTitle };
  },
};
</script>
